import { Box, Typography } from '@mui/material';

import { RenderPrevNextBtn } from './render-prevnext-btn';

type ChannelStepLayoutProps = {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  isNextDisabled?: boolean;
  sx?: any;
  onNext?: () => void;
};

export function ChannelStepLayout({
  title,
  subtitle,
  children,
  isNextDisabled,
  sx,
  onNext,
}: ChannelStepLayoutProps) {
  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', minHeight: 400 }}>
      {(title || subtitle) && (
        <Box sx={{ mb: 3 }}>
          {title && (
            <Typography variant="h4" component="h1" gutterBottom fontWeight="fontWeightBold">
              {title}
            </Typography>
          )}
          {subtitle && (
            <Typography variant="body1" color="text.secondary">
              {subtitle}
            </Typography>
          )}
        </Box>
      )}

      <Box sx={{ flex: 1, overflow: 'auto', mb: 2, pt: 1 }}>{children}</Box>

      <RenderPrevNextBtn isNextDisabled={isNextDisabled} onNext={onNext} />
    </Box>
  );
}
